/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pwa_Install_Got_ItInputs */

const cs_pwa_install_got_it = /** @type {(inputs: Pwa_Install_Got_ItInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rozumím`)
};

const en_pwa_install_got_it = /** @type {(inputs: Pwa_Install_Got_ItInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Got it`)
};

/**
* | output |
* | --- |
* | "Got it" |
*
* @param {Pwa_Install_Got_ItInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const pwa_install_got_it = /** @type {((inputs?: Pwa_Install_Got_ItInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pwa_Install_Got_ItInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pwa_install_got_it(inputs)
	return cs_pwa_install_got_it(inputs)
});